module.exports = __webpack_public_path__ + "static/owasptop10-c5315b191cb74da7fb5cccde10c69bdc.png";